var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158.793,
    height: 143.511,
    viewBox: "0 0 158.793 143.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3530",
    "data-name": "Rectangle 3530",
    width: 158.793,
    height: 143.511,
    fill: "#0c646e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10939",
    "data-name": "Group 10939",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10938",
    "data-name": "Group 10938",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30374",
    "data-name": "Path 30374",
    d: "M0,14.306A8.6,8.6,0,0,1,8.581,5.725H38.613a8.6,8.6,0,0,1,8.581,8.581V91.531a8.6,8.6,0,0,1-8.581,8.581H8.581A8.6,8.6,0,0,1,0,91.531ZM17.161,82.951H30.032V22.886H17.161Z",
    transform: "translate(0 43.402)",
    fill: "#0c646e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30375",
    "data-name": "Path 30375",
    d: "M67.958,18.42A4.409,4.409,0,0,0,63.9,17.279a4.27,4.27,0,0,0-3.08,2.814L54.546,38.962a8.366,8.366,0,0,1-1.776,3.02L33.464,63.434A8.5,8.5,0,0,1,27.1,66.283H20.661v60.064h79.774a4.3,4.3,0,0,0,4.187-3.355l10.288-46.25A8.611,8.611,0,0,0,113.2,69.5a8.492,8.492,0,0,0-6.667-3.218H72.145a8.591,8.591,0,0,1-8.383-10.46l7.045-31.705a4.241,4.241,0,0,0-1.141-3.956L67.923,18.42Zm-23.4-3.758A21.468,21.468,0,0,1,80.091,6.287L81.8,8.029a21.4,21.4,0,0,1,5.766,19.813l-4.728,21.28h23.7a25.691,25.691,0,0,1,25.107,31.3l-10.262,46.292a21.438,21.438,0,0,1-20.945,16.792H12.081A8.6,8.6,0,0,1,3.5,134.928V57.7a8.6,8.6,0,0,1,8.581-8.581h11.2l15.548-17.3Z",
    transform: "translate(26.532 0.005)",
    fill: "#0c646e",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYou);
export default __webpack_public_path__ + "static/media/thank-you.7e3aa26250c190b94d495391336987c7.svg";
export { ForwardRef as ReactComponent };